import { useState } from 'react';
import { heroImage } from '@/mocks/comicData';

interface HeroProps {
  onSearch: (keyword: string) => void;
}

const quickChips = ['热血冒险', '恋爱甜宠', '奇幻异界', '悬疑烧脑', '搞笑日常'];

export default function Hero({ onSearch }: HeroProps) {
  const [keyword, setKeyword] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = keyword.trim();
    onSearch(value);
    document.getElementById('hot')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[680px]">
      <img
        src={heroImage}
        alt="虫虫漫画分类大全封面插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/55"></div>

      <div className="relative mx-auto w-full max-w-5xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur-sm">
          <i className="ri-sparkling-2-fill text-accent-400"></i>
          国漫 · 日漫 · 分类大全
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
          虫虫漫画<span className="text-accent-400">分类大全</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-white/85 md:text-lg">
          按题材类型整理好国漫日漫，热门连载、经典全本都能分类直达。
          想看什么类型，直接点进对应分类，翻起来省时间，追更找书都方便。
        </p>

        {/* 搜索框 */}
        <form
          onSubmit={submit}
          className="mx-auto mt-8 flex max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:bg-background-50/95 sm:p-1.5 sm:shadow-lg"
        >
          <label htmlFor="hero-search" className="sr-only">
            搜索漫画
          </label>
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-4 py-3 sm:bg-transparent sm:py-1.5">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              id="hero-search"
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入书名或题材，如：热血、恋爱、踏星而行…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:py-2.5"
          >
            开始找书
          </button>
        </form>

        {/* 快速分类 */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-sm text-white/70">快速入口：</span>
          {quickChips.map((chip) => (
            <a
              key={chip}
              href="#category"
              className="whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-sm text-white transition-colors hover:bg-accent-500 hover:text-foreground-950"
            >
              {chip}
            </a>
          ))}
        </div>

        <p className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70">
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-accent-400"></i>累计收录 6800+ 部
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-archive-2-line text-accent-400"></i>8 大题材大类
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-accent-400"></i>每日更新连载
          </span>
        </p>
      </div>
    </section>
  );
}